/** Shared color picking: the 70-dot rainbow grid used for workspace branding AND client colors. */

/** Studio Llama sienna — the default scheme; picking it clears custom branding. */
export const DEFAULT_PRIMARY = '#874a26'

export const hslToHex = (h: number, s: number, l: number): string => {
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    const c = l / 100 - (s / 100) * Math.min(l / 100, 1 - l / 100) * Math.max(-1, Math.min(k - 3, 9 - k, 1))
    return Math.round(255 * c).toString(16).padStart(2, '0')
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

/** Hue columns of the picker grid (also drives the column count in the Team picker). */
export const PALETTE_COLS = 14

/**
 * 70 dots: 14 hues sweeping the rainbow left→right (red → coral → amber → gold →
 * chartreuse → leaf → forest → emerald → teal → azure → blue → indigo → violet →
 * magenta), 5 lightness rows fading top→bottom. The amber-hue row-4 cell is the
 * EXACT stock sienna (DEFAULT_PRIMARY) so the default scheme is always present.
 */
export const PALETTE: string[] = (() => {
  const HUES = [4, 22, 42, 68, 90, 110, 129, 152, 178, 204, 232, 262, 292, 322]
  const ROWS = [
    { s: 64, l: 74 },
    { s: 60, l: 60 },
    { s: 58, l: 47 },
    { s: 56, l: 34 },
    { s: 60, l: 20 },
  ]
  const grid = ROWS.map((r) => HUES.map((h) => hslToHex(h, r.s, r.l)))
  grid[3]![1] = DEFAULT_PRIMARY
  return grid.flat()
})()

/** Compact dot-grid color picker recipe (radio semantics). `value` compares case-insensitively. */
export function dotClasses(
  active: boolean,
  { ringOffset = 'ring-offset-[color:rgb(var(--bg-elev))]', size = 'h-6 w-6' } = {},
): string {
  return `${size} rounded-full transition ${active ? `ring-2 ring-[color:rgb(var(--fg))] ring-offset-2 ${ringOffset}` : 'hover:scale-110'}`
}
